import EcoSection from 'eco-design/base/eco-section';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import Button from '../components/button';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from '@elem/ui/ef-picture';
import { getSolarRecommand2 } from '@/service/solar-calculator';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import { useLang } from '@/app/utils/useLang';

const Flexible: React.FC = () => {
    const { locale = 'ca' } = useRouter();
    const { t } = useLang('flexible');
    const items = [
        {
            img: '',
            title: t('a_title'),
            desc: t('a_desc'),
            price: '',
            discountPrice: 0,
            productId: '8231332380826',
            variantId: '44902384730266',
            label: 'Plug & play home backup solution.',
            note: '*Installation service not included.',
            buyNow: 'https://ecoflow-canada.myshopify.com/cart/44902384730266:1?channel=buy_button',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station?variant=44902384730266',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747379156719/img.png',
            title: t('b_title'),
            desc: t('b_desc'),
            price: '',
            discountPrice: 0,
            productId: '15093938192755',
            variantId: '52597126234483',
            label: 'Plug & play home backup solution.',
            note: '*Installation service not included.',
            buyNow: 'https://ecoflow-canada.myshopify.com/cart/52597126234483:1?channel=buy_button',
            learnMore: 'https://ca.ecoflow.com/products/ecoflow-delta-pro-3-delta-pro-3-extra-battery-smart-home-panel-2?variant=52597126234483',
        },
        {
            img: '',
            title: t('c_title'),
            desc: t('c_desc'),
            price: '',
            discountPrice: 0,
            productId: '15070007853427',
            variantId: '52476795552115',
            label: 'Plug & play home backup solution.',
            note: '*Installation service not included.',
            buyNow: 'https://ecoflow-canada.myshopify.com/cart/52476795552115:1?channel=buy_button',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-3-smart-generator-4000-transfer-switch',
        },
        {
            img: '',
            title: t('d_title'),
            desc: t('d_desc'),
            price: '',
            discountPrice: 0,
            productId: '14621037855091',
            variantId: '51648181010803',
            label: 'Plug & play home backup solution.',
            note: '*Installation service not included.',
            buyNow: 'https://ecoflow-canada.myshopify.com/cart/51648181010803:1?channel=buy_button',
            learnMore: 'https://ca.ecoflow.com/products/ecoflow-delta-pro-transfer-switch-306a1?variant=51648181010803',
        },
    ];

    const [reactiveItems, setReactiveItems] = useState(items);
    useEffect(() => {
        getItemInfo();
    }, []);

    async function getItemInfo() {
        const variantIds = items.map((item) => item.variantId);
        const res = await getSolarRecommand2({ variantIds }, locale);
        if (res.code === '0') {
            const newItems = cloneDeep(reactiveItems);
            res.data.forEach((item: any) => {
                const newItem = newItems.find((_item) => _item.variantId === item.variantId);
                if (newItem) {
                    newItem.img = item.variantImg;
                    newItem.price = item.price;
                    newItem.discountPrice = item.discountPrice;
                }
            });

            setReactiveItems(newItems);
        }
    }

    function link(url: string) {
        window.open(url, '_blank');
    }

    return (
        <div className={styles.Flexible}>
            <EcoSection title="Flexible Home Backup" desc="Ideal for partial home backup and flexible power use" />
            <div className="products-pc">
                {reactiveItems.map((item) => {
                    return (
                        <div className="product" key={item.title}>
                            <EcoImg pc={item.img} />
                            <div className="wrapper">
                                <div className="title">{item.title}</div>
                                <div className="desc">{item.desc}</div>
                                {/* <div className="label">{item.label}</div> */}
                                <div>
                                    <span className="price">{FormatMoneyLocal(item.price || 0, locale)}</span>
                                    {item.discountPrice && <span className="discount-price">{FormatMoneyLocal(item.discountPrice || 0, locale)}</span>}
                                </div>
                                {/* <div className="note">{item.note}</div> */}
                                <div className="btns">
                                    <Button type="buy" onClick={() => link(item.buyNow)}>
                                        Buy now
                                    </Button>
                                    <Button type="more" onClick={() => link(item.learnMore)}>
                                        Learn more
                                    </Button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="products-h5">
                <Swiper
                    slidesPerView={1}
                    centeredSlides={false}
                    spaceBetween={27}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Pagination]}
                >
                    {reactiveItems.map((item) => {
                        return (
                            <SwiperSlide className="product" key={item.title}>
                                <EFPicture src={item.img} />
                                <div className="wrapper">
                                    <div className="title">{item.title}</div>
                                    <div className="desc">{item.desc}</div>
                                    {/* <div className="label">{item.label}</div> */}
                                    <div>
                                        <span className="price">{FormatMoneyLocal(item.price || 0, locale)}</span>
                                        {item.discountPrice && <span className="discount-price">{FormatMoneyLocal(item.discountPrice || 0, locale)}</span>}
                                    </div>
                                    {/* <div className="note">{item.note}</div> */}
                                    <div className="btns">
                                        <Button type="buy" onClick={() => link(item.buyNow)}>
                                            Buy now
                                        </Button>
                                        <Button type="more" onClick={() => link(item.learnMore)}>
                                            Learn more
                                        </Button>
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </div>
    );
};

export default Flexible;
